import styled from 'styled-components';
import breakpoints from '@styles/constants.styled';

export const StyledButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  outline: none;
  
  @media screen and ${breakpoints.Device.mobile} {
    padding-left: 30px;
  }
`;